import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useAppManager } from 'core/hooks';
import { Link } from 'core/routing';

import { Button } from 'components';

import { Table } from 'libs/connection';
import { SortByAction, FilterByAction } from 'libs/connection/actions';

import { useClientStore, useRouterStore } from 'apps/hooks';
import { CenteredButtonWrapper } from 'apps/components/shared';
import { IntermediatorSwitcherDescription } from 'apps/client/components/ChangePortalBanner';
import { SystemCategory } from 'constants/global';

import { RFQConnManager } from './connManager';
import { ShipmentQuoteButton } from '../ShipmentQuoteButton';

const baseActions: Record<string, any> = {
  leftActions: [SortByAction, FilterByAction],
  rightActions: [],
};

const RFQList = observer(
  ({
    maxItems,
    disableSortingFilteringFeatures = false,
  }: {
    maxItems?: number;
    disableSortingFilteringFeatures?: boolean;
  }) => {
    const clientStore = useClientStore();
    const routerStore = useRouterStore();
    const conn = useAppManager(RFQConnManager, null);

    const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';

    let bottomButton = null;
    let numRows = conn?.nodes?.length;
    if (!numRows) numRows = 0;
    if (maxItems && maxItems <= numRows) {
      const params = { spacePath: clientStore.activeSpace?.path };
      bottomButton = (
        <CenteredButtonWrapper>
          <Link name='workspace.rfqs' params={params}>
            <Button
              size='default'
              variant='primary'
              outline
              text='Show all'
              icon='arrow_right'
              iconPosition='right'
            />
          </Link>
        </CenteredButtonWrapper>
      );
    }

    const intermediatorActions = [
      routerStore.route.name !== 'workspace' &&
        IntermediatorSwitcherDescription,
    ].filter(Boolean);

    let actionButtons = {
      ...baseActions,
    };

    if (isIntermediator) {
      actionButtons = {
        ...actionButtons,
        rightActions: [...intermediatorActions, ShipmentQuoteButton],
      };
    } else {
      actionButtons = { ...baseActions, rightActions: intermediatorActions };
    }

    if (disableSortingFilteringFeatures && intermediatorActions.length < 1) {
      actionButtons = null;
    }

    return (
      <div id='tableWrapper' className='mt-2'>
        <Table
          {...{
            contentName: SystemCategory.RFQs,
            columns: conn.finalColumns,
            conn,
            actions: actionButtons,
            maxRows: maxItems,
          }}
        />
        {bottomButton}
      </div>
    );
  },
);

export default RFQList;
